import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  margin: 4rem auto 2rem;
  color: ${props => props.theme.colors.secondary};

  section {
    font-size: ${props => props.theme.fontSize.summary};
    line-height: ${props => props.theme.lineHeight.summary};
    margin: 3rem 3rem;
    text-align: center;
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      margin: 2rem 1rem;
      font-size: ${props => props.theme.fontSize.summaryTablet};
      line-height: ${props => props.theme.lineHeight.summaryTablet};
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin: 2rem 0;
  }
`

const CaseBox = ({ children }) => <Container>{children}</Container>

export default CaseBox
